import { render, staticRenderFns } from "./UnitCode.vue?vue&type=template&id=20788c51&scoped=true"
import script from "./UnitCode.vue?vue&type=script&lang=js"
export * from "./UnitCode.vue?vue&type=script&lang=js"
import style0 from "./UnitCode.vue?vue&type=style&index=0&id=20788c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20788c51",
  null
  
)

export default component.exports